module.exports = __webpack_public_path__ + "static/media/oberflex-teck-2560x1440.91259d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-teck-2560x1440.jpg
// module id = 1059
// module chunks = 37